<template>
  <v-container style="max-height:100vh;">
    <v-row class="ma-0 pa-0" >
        <v-spacer/>
        <v-card-title class="px-0">Noticias</v-card-title>
        <v-spacer/>
    </v-row>
    <v-row class="ma-0 pa-0" style="position:absolute!important; top:13px;">
        <v-btn class="mr-2 pt-7" to='/' icon><v-icon>mdi-chevron-left</v-icon></v-btn>
    </v-row>
    <div v-if="events.length>0">
    <v-card v-for="(event, index) in events" :key="index" class="mb-4 elevation-0 py-3 px-5" @click="openDetail(event)">
        <v-card-title style="font-size:18px;" class="ma-0 pa-0">{{event.title}}</v-card-title>
        <v-card-subtitle style="font-size:12px; color:grey; font-weight:600;" class="ma-0 pa-0 mt-1">{{event.only_date}}</v-card-subtitle>
    </v-card>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card v-if="dialog" class="elevation-0">
            <v-toolbar>
                <v-card-title>{{selected_event.title}}</v-card-title>
                <v-spacer/>
                <v-icon class="mr-4" @click="dialog=false, selected_event={}">mdi-close</v-icon>
            </v-toolbar>
            
            <div class="mb-6" v-if="selected_event && selected_event.featured_image">
                <v-img
                :src="fileUrl(selected_event.featured_image)"
                />
                <div class="mt-6 mx-5" v-if="isPdf(selected_event.featured_image)">
                    <v-btn :href="fileUrl(selected_event.featured_image)" target="_blank" text small>
                        <v-icon left small>mdi-file-pdf-box</v-icon>Abrir PDF
                    </v-btn>
                </div>
            </div>

            <v-row class="my-6 mx-7">
                <v-chip dark small :color="selected_event.activity_type.color" style="font-weight:500; border-radius:3px;">{{selected_event.activity_type.name}}</v-chip>
                <v-spacer/>
                <v-card-subtitle style="color:grey; font-weight:600;" class="ma-0 pa-0">{{selected_event.only_date}}</v-card-subtitle>
            </v-row>
            
            <div class="htmlcontent my-6 px-8 md:px-0 content pb-6" v-html="htmlContent(selected_event.description)"></div>
            
        </v-card>
    </v-dialog>
    </div>
    <div v-else style="text-align:center; filter:opacity(.5);" class="mt-12 pt-12">
        No hay noticias aún
        <br/>
        <br/>
        <span style="font-size:100px;">{{':('}}</span>
    </div>
    
  </v-container>
</template>

<script>
import axios from "axios"
export default {
    data(){
        return{
            loader:true,
            dialog:false,
            events:[],
            selected_event:{}
        }
    },
    methods:{
        openDetail(event){
            this.dialog = true
            this.selected_event = event
        },
        htmlContent(html){
            return html
            var content = html
            content = content.replace(/<iframe[^>]*src="([^"]+)"[^>]*><\/iframe>/g, function(match, src) {
            return '<video width="100%" height="auto" style="margin:30px 0px;" controls autoplay="false"><source src="' + src + '" type="video/mp4"></video>';
            });
            for(var i=0; i<100; i++){
            content = content.replace('&gt;', '>').replace('&lt;', '<').replace('&amp;amp', '&amp').replace('&amp;mdash', '&mdash')
            }
            return '<div class="content-style">' + content + '</div><style> .content-style div :first-child { font-size: 14px; } .content-style h4 { font-size: 18px; text-align: justify; } .content-style { word-wrap: break-word; display: flex; justify-content: center; flex-wrap: wrap; } </style>';
        },
        isPdf(name) {
            if (!name) return false
            return /\.pdf(\?.*)?$/i.test(name)
        },
        fileUrl(name) {
            if (!name) return ''
            return /^https?:\/\//i.test(name)
            ? name
            : (process.env.VUE_APP_FILES_ROUTE || 'https://peach.blitzhub.mx/files/') + name
        },
    },
    created(){
        axios.get(process.env.VUE_APP_BACKEND_ROUTE + 'api/v1/activities?filter[activity_type_id]=2&filter[influencer]=true').then(response=>{
            this.events = response.data.data
            this.loader = false
        })
    }
}
</script>

<style>

</style>